import { styled } from "styled-components";

import { Spinner } from "common/components";

export const StyledLoadingIndicator = styled(Spinner)`
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  margin-left: 0.5rem;
`;
